module.exports = __webpack_public_path__ + "img/supermetrics.0b977704.jpg";